import Bid from './bidsResource';

import transformBids from '../../transformers/bids/bidsTransformer';
import errorTransformer from '../../transformers/errorTransformer';

/**
 * Adds bid
 *
 * @async
 * @param {object} bid
 * @param {string} bid.campaignId
 * @param {string} bid.query
 * @param {number} bid.priceOffer
 * @param {string} bid.matchingType
 * @param {string} [bid.referrer=null]
 * @returns {Promise} Promise object represents an object with message and data(bid) properties
 */
function addBid({ campaignId, referrer, ...bidInfo }) {
  return addBulkBids({
    campaignId,
    bids: [bidInfo],
    referrer,
  }).then(({ errors, data, message }) => {
    if (errors.length) {
      throw new Error(errors[0].message);
    }
    return {
      data: data[0],
      message,
    };
  });
}

/**
 * Adds array of bids
 *
 * @async
 * @param {object} data
 * @param {string} data.campaignId
 * @param {array} data.bids
 * @param {string} [data.referrer=null]
 * @returns {Promise}
 */

function addBulkBids({ campaignId, bids, referrer = null }) {
  const normalizedBids = bids.map(bidInfo => ({
    campaign: campaignId,
    referrer,
    ...bidInfo,
  }));

  return Bid.save(
    {
      itemId: campaignId,
    },
    { data: normalizedBids },
  )
    .then(({ body: { data = [], message = '', errors = [] } }) => ({
      data: transformBids(data),
      message,
      errors,
    }))
    .catch(errorTransformer);
}

export default {
  addBulkBids,
  addBid,
};
